var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      class: {
        "nav-item": true,
        "nav-item menu-is-opening menu-open": _vm.isOpen,
      },
    },
    [
      _c(
        "a",
        {
          staticClass: "nav-link",
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggleElement.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { class: ["nav-icon", _vm.item.icon] }),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t(_vm.item.text)) +
                "\n            "
            ),
            _c("i", { staticClass: "fas fa-angle-left right" }),
            _vm._v(" "),
            _vm.showChildrenNumber
              ? _c("span", { staticClass: "badge badge-info right" }, [
                  _vm._v(_vm._s(_vm.childrenNumber)),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("Menu", {
        attrs: {
          level: _vm.level,
          items: _vm.childrens,
          groupProperty: _vm.groupProperty,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }